import {label} from "@/class/label";

export class hotspot extends label{
    
    objectType = "hotspot";
    parentObjectType = "interactive_image";

    data = [
        ...this._default.coords
    ]
    
    constructor() {
        super();
        this.init();
    }
    
}